import { handleActions } from 'redux-actions';
import { SYSTEM_UNAVAILABLE_BANNER_KEY } from '../services/contentful.constants';

const INITIAL_STATE = {
  [SYSTEM_UNAVAILABLE_BANNER_KEY]: {
    subtitle: '',
    title: '',
  },
};

const ENTRY_INITIAL_STATE = {
  data: null,
  error: null,
  loading: false,
};

export default handleActions({
  CONTENTFUL_ENTRIES_FAILED: (state, { payload: { error, key } }) => ({
    ...state,
    [key]: {
      ...state[key],
      error,
      loading: false,
    },
  }),
  CONTENTFUL_ENTRIES_LOADED: (state, { payload: { data, key } }) => ({
    ...state,
    [key]: {
      data,
      error: null,
      loading: false,
    },
  }),
  GET_CONTENTFUL_ENTRIES: (state, { payload: { key } }) => ({
    ...state,
    [key]: {
      ...ENTRY_INITIAL_STATE,
      ...state[key],
      loading: true,
    },
  }),
}, INITIAL_STATE);
